class SliderGallerySection {
    constructor() {
        // view
        this.name = 'slider-gallery-section';
        this.components = document.querySelectorAll(`.${this.name}`);

        if (this.components) {
            this.init();
        }
    }

    init() {
        this.components.forEach((comp) => {
            let sliderNode = comp.querySelector('.splide');
            if (!sliderNode) return;
            this.initSlider(sliderNode);
        });
    }
    initSlider(slider) {
        const sliderNode = new Splide(slider, {
            type: "slide",
            rewind: true,
            arrows: false,
            pagination: true,
            gap: '2rem',
            destroy: true,
            breakpoints: {
                961: {
                    destroy: false,
                }
            }
        });
        sliderNode.mount();
    };
}


const sliderGallerySection = new SliderGallerySection();

